import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RedirectComponent } from './component/redirect/redirect.component';
import { PageConfig } from './config/page.config';
import { EmptyComponent } from './component/empty/empty.component';

const routes: Routes = [

  {
    path : '',
    // component: EmptyComponent,
    loadChildren : () => import('./view/app-view/app-view.module').then(__ => __.AppViewModule),
  },
  {
    path : '',
    // component: EmptyComponent,
    loadChildren : () => import('./view/other-view/other-view.module').then(__ => __.OtherViewModule),
  },
  
  {
    path : '**',
    component : RedirectComponent,
    data : {
      to : PageConfig['notFound']
    },
    
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
